import { Stack, SimpleGrid, Divider, Text } from "@mantine/core"
import { Tuple } from "../../../@client/System"

interface Props<T> {
  groupedItems: Tuple<string, T[]>[]
  renderItem: (item: T) => React.ReactNode
}
export function GroupedSimpleGrid<T>({ groupedItems, renderItem }: Props<T>) {
  {
    return groupedItems.map((group, i) => (
      <Stack key={i}>
        <Text fz={"lg"} fw={500}>
          {group[0]}
        </Text>
        <SimpleGrid cols={{ base: 1, sm: 2, md: 3, lg: 4, xl: 5 }}>
          {group[1]?.map((item) => renderItem(item))}
        </SimpleGrid>
        {i !== groupedItems.length - 1 && <Divider />}
      </Stack>
    ))
  }
}
